
import {
  IMessageModel,
} from '@tencentcloud/chat-uikit-engine';
import TUIEmojiPluginDetail from './emoji-detail/index.vue';
import TUIEmojiPluginAction from './emoji-action/index.vue';

interface IEmojiReactionProps {
  message: IMessageModel;
  type?: string;
  emojiConfig: Record<string, any>;
}

export default {
  components: {
    TUIEmojiPluginDetail,
    TUIEmojiPluginAction,
  },
  props: {
    message: {
      type: Object as () => IMessageModel,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
    emojiConfig: {
      type: Object as () => Record<string, any>,
      default: () => ({}),
    },
  },
  setup(props: IEmojiReactionProps) {
    return {
      props,
    };
  },
};
